/**
 * Maximum number of pages to index for SEO
 * Business rule: Don't link past this page to avoid indexing too many pages or wasting crawl budget
 */
export const MAX_INDEXABLE_PAGES = 5;